import { render, staticRenderFns } from "./HistoralAvls.vue?vue&type=template&id=2c9d24ee"
import script from "./HistoralAvls.vue?vue&type=script&lang=js"
export * from "./HistoralAvls.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports